import { render, staticRenderFns } from "./VTravelPricesForm.vue?vue&type=template&id=210ddb15&"
import script from "./VTravelPricesForm.vue?vue&type=script&lang=js&"
export * from "./VTravelPricesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports